import React from 'react';
import './ccdsHeader.css';

const CcdsHeader = () => {

  return (
    <div className="pept__ccdsHeader section__padding" id="icd">
        <div className="pept__ccdsHeader-content">
            <h1 className="gradient__text">
                HRS Cardiac Rhythm Device Therapy Exam for the Physician
            </h1>
            <h2>
                CCDS Exam
            </h2>
            <p>
            The IBHRE Test Writing Committee and the National Board of Medical Examiners designed the CCDS certification examination. To maintain certification, participants must complete Verification of the Continuing Education once every five years and recertify by re-examination once every ten years.
            </p>
            <h2>
                About the Exam:
            </h2>
            <p>
                This examination assesses essential clinical knowledge relevant to implanting pacemakers and ICDs and the diagnosis and treatment of patients who suffer from heart rhythm disorders. The exam consists of 200 multiple-choice questions and is administered within a five-hour time limit. Candidates should have broad knowledge in three general areas:
            </p>
            <ul>
                <li>
                    Basic Science
                </li>
                <li>
                    Applied science and technology
                </li>
                <li>
                    Clinical practice of cardiac pacing and management of tachy-arrhythmias by the implantable cardioverter-defibrillator (ICD)
                </li>
            </ul>

            <h2>
                Target Audience:
            </h2>
            <p>
                Physicians and physician fellows-in-training who implant pacemakers and implantable cardioverter defibrillators (ICDs) or perform electrophysiology studies.
            </p>
            <ul>
                <li>
                    General Cardiologists
                </li>
                <li>
                    Electrophysiologists
                </li>
                <li>
                    Pediatricians
                </li>
                <li>
                    Internists
                </li>
                <li>
                    Surgeons
                </li>
                <li>
                    Cardiovascualr specialists
                </li>
                <li>
                    Thoracic surgeons
                </li>
                <li>
                    Emergency care physicians
                </li>
                <li>
                    Anesthesiologists
                </li>
                <li>
                    Hospitals
                </li>
                <li>
                    General practitioners
                </li>
            </ul>
            <h2>
                CCDS Exam Eligibility Policy
            </h2>
            <p>
            </p>
            <p>  
                The purpose of this policy is to articulate and define the standard eligibility requirement held by IBHRE to qualify for the above stated certification exam and the documentation required from candidates to prove eligibility.
            </p>
            <h2>
                Criteria:
            </h2>
            <p>
                Applicants for the Cardiac Rhythm Device Therapy Examination for the Physician must be a licensed physicians involved in the practice of heart rhythm management. Physicians applying for the certification must also:
            </p>
            <ul>
                <li>
                    Have completed a fellowship in Cardiology (adult or pediatric) or Clinical Cardiac Electrophysiology
                </li>
                <p>OR</p>
                <li>
                    Have documented a minimum of one year of direct, substantial involvement in the care of cardiac rhythm device therapy patients. Exposure includes a minimum of 100 device interrogations with reprogramming as needed. The devices should include pacemakers, implantable defibrillators, cardiac resynchronization devices and implantable loop recorders/cardiac monitors.
                </li>
            </ul>
            <h2>
                Required Documentation:
            </h2>
            <p>
            Upon submitting an application for the exam, all candidates must provide appropriate documentation as evidence of the candidate’s eligibility:
            </p>
            <ul>
                <li>
                    Physicians must include a copy of their current medical license from the state, province or country where they currently practice with their application.
                </li>
                <li>
                    Physicians must include a copy of their certificate/diploma of completion of medical school and residency programs specifying dates of completion.
                </li>
                <li>
                    Physicians must include a certificate of completion of the necessary fellowship training program or attestation form a supervisor or colleague verifying direct involvement in managing device therapy for patients for a minimum of one year (refer to IBHRE's eligibility requirements).
                </li>
            </ul>
            <p>
            IBHRE reserves the right to independently verify the licenses, credentials and employment status of all examination candidates. The candidate’s signature on his or her examination application duly authorizes IBHRE to conduct such independent verification
            </p>
            <p>See the IHBRE website for more info <a href="https://www.ibhre.org/">https://www.ibhre.org/</a></p>
        </div>
    </div>
  )
}

export default CcdsHeader